import React from "react";
import useDeviceType from "../hooks/useDeviceType";

const ResponsiveLayout = ({ MobileComponent, DesktopComponent }) => {
  const isMobile = useDeviceType();
  
  return isMobile ? <MobileComponent /> : <DesktopComponent />;
};

export default ResponsiveLayout;
